import type { FactFinderFacet } from '@ab-core/graphql/dist';
import { getSearchFilterParameterFromUrl } from '../../params';

type FixedFilterType = {
    defaultPositionInArray: number;
    urlFilter: string;
    needUser: boolean;
    factFinderFacet: FactFinderFacet;
    defaultElements: FactFinderFacet['elements'];
    defaultSelectedElements: FactFinderFacet['selectedElements'];
};

export const fixedFiltersMock = Object.freeze<Array<FixedFilterType>>([
    {
        defaultPositionInArray: 1,
        urlFilter: 'purchase:ja',
        needUser: true,
        factFinderFacet: {
            associatedFieldName: 'purchase',
            elements: [],
            selectedElements: [],
            filterStyle: 'DEFAULT',
            name: 'Bereits gekaufte Artikel',
            type: 'TEXT'
        },
        defaultElements: [
            {
                text: 'ja',
                selected: 'FALSE'
            }
        ],
        defaultSelectedElements: [
            {
                text: 'ja',
                selected: 'TRUE'
            }
        ]
    }
]);

export const changeSelectionState = (filter: FixedFilterType): FactFinderFacet => {
    const params = getSearchFilterParameterFromUrl();
    const activeFilters = params.filter;

    const existingIndex = activeFilters.findIndex((activeFilter) => activeFilter === filter.urlFilter);

    if (existingIndex === -1) {
        return {
            ...filter.factFinderFacet,
            elements: filter.defaultElements
        };
    }

    return {
        ...filter.factFinderFacet,
        selectedElements: filter.defaultSelectedElements
    };
};
